import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        partners_with_unconfirmed_emails: {
          header: 'HEADER',
          email_has_sent: 'EMAIL_SENT',
          modal_window: {
            header: 'MODAL_HEADER',
            url_for_confirming_email: 'MODAL_URL_FOR_CONFIRMING_EMAIL',
            copy: 'MODAL_COPY',
            cancel: 'MODAL_CANCEL',
          },
        },
      },
    },
  }));
}
